<template>
    <div class="choose-user-identity">
        <div class="user-identity-title">Choose your identity</div>
        <div class="user-identity-list">
            <div
                class="user-identity-item"
                :class="{ selected: curChooseCareerSelected === 1 }"
                @click.stop="_hdanleChooseCareerSelected(1)"
            >
                <div class="user-identity-item-img-cont">
                    <img src="@/assets/icons/icon_default_user_new.svg" />
                </div>
                <div class="user-identity-item-name">Sign up as Member</div>
            </div>

            <div
                class="user-identity-item"
                :class="{ selected: curChooseCareerSelected === 2 }"
                @click.stop="_hdanleChooseCareerSelected(2)"
            >
                <div class="user-identity-item-img-cont">
                    <img src="@/assets/icons/icon_default_doctor_new.svg" />
                </div>
                <div class="user-identity-item-name">Sign up as Doctor</div>
            </div>
        </div>

        <!-- <div class="next-btn-cont">
            <n-button
                :color="
                    !isDisabledChooseCareerSelected
                        ? '#000000'
                        : 'rgba(0, 0, 0, 0.2)'
                "
                text-color="#ffffff"
                icon-placement="right"
                :disabled="isDisabledChooseCareerSelected"
                @click="_handleChooseCareerNext"
            >
                Log In
            </n-button>
        </div> -->
    </div>
</template>

<script lang="ts" setup>
import { NButton } from "naive-ui";
import { ref, computed, watch } from "vue";
import { MessageAlert } from "@/composables/useMessageAlert";
import { UserRole } from "@/constant";

const props = defineProps({
    curRoleType: {
        type: String,
        default: () => {
            return "";
        },
    },
});
const emits = defineEmits(["onNext"]);

const curChooseCareerSelected = ref<number>(0);
const isDisabledChooseCareerSelected = computed(() => {
    return curChooseCareerSelected.value ? false : true;
});

watch(
    () => props.curRoleType,
    (newV) => {
        curChooseCareerSelected.value = newV === UserRole.User.toUpperCase() ? 1 : newV === UserRole.Doctor.toUpperCase() ? 2 : 0;
    },
    { immediate: true }
);

const _hdanleChooseCareerSelected = (type: number) => {
    curChooseCareerSelected.value = type;
    setTimeout(()=>{
        _handleChooseCareerNext();
    }, 1000)
};

// 注册-选择完职业之后点击next按钮
const _handleChooseCareerNext = () => {
    if (isDisabledChooseCareerSelected.value) {
        MessageAlert("Please choose a User identity");
        return;
    }
    emits("onNext", curChooseCareerSelected.value);
};
</script>

<style lang="scss" scoped>
.choose-user-identity {
    margin-top: -20px;
    .user-identity-title{
        margin-bottom: 20px;
        color: #000;
        text-align: center;
        font-size: 28px;
        font-style: normal;
        font-weight: 500;
        line-height: 180%; /* 50.4px */
    }
    .user-identity-list {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        gap: 40px;

        .user-identity-item {
            width: 100%;
            padding: 40px 35px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            box-sizing: border-box;
            border-radius: 8px;
            border: 1px solid rgba(0, 0, 0, 0.20);
            gap: 16px;
            cursor: pointer;

            &:hover {
                box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.10);
            }

            &.selected {
                position: relative;
                box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.2);
            }

            &.selected::after{
                content: "";
                position: absolute;
                bottom: -20px;
                left: 50%;
                transform: translateX(-50%);
                width: 40px;
                height: 40px;
                border-radius: 50%;
                background-image: url("@/assets/icons/icon_selected_black.svg");
                background-color: #000000;
                background-position: center center;
                background-size: 50% 50%;
                background-repeat: no-repeat;
                overflow: hidden;
            }

            .user-identity-item-img-cont {
                display: flex;
                width: 100px;
                height: 100px;
                border-radius: 50%;
                align-items: center;
                justify-content: center;
                border: 1px solid #E7EFFF;
                background-color: #E7EFFF;
                overflow: hidden;

                img {
                    width: 40px;
                    height: 60px;
                    object-fit: fill;
                }
            }

            .user-identity-item-name {
                color: #000000;
                font-size: 20px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }
        }
    }

    .next-btn-cont {
        position: absolute;
        left: 60px;
        right: 60px;
        bottom: 40px;
        height: 60px;

        :deep(.n-button) {
            width: 100%;
            height: 60px;
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            line-height: 16px;
            border-radius: 30px;
        }
    }
}
@media screen and (max-width: 1024px) and (min-width: 744px) {
}
@media screen and (max-width: 744px) {
    .choose-user-identity {
        .user-identity-list {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 16px;
            .user-identity-item {
                flex: 1 auto;
                height: 80px;
                overflow: hidden;

                .user-identity-item-img-cont {
                    width: 44px;
                    height: 40px;

                    img {
                        width: 44px;
                        height: 40px;
                        object-fit: fill;
                    }
                }

                .user-identity-item-name {
                    margin-left: 8px;
                    font-size: 18px;
                }
            }
        }

        .next-btn-cont {
            position: absolute;
            left: 12px;
            right: 12px;
            bottom: 40px;
            height: 60px;

            :deep(.n-button) {
                width: 100%;
                height: 60px;
                
                font-size: 18px;
                font-style: normal;
                font-weight: 600;
                line-height: 16px;
            }
        }
    }
}
</style>
